<app-request-list
    [requestOptions]="requestOptions"
    [currentUser]="currentUser">
</app-request-list>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-list-page/request-list-page.component.html